module.exports = "../dist/img/mini-27.480e.jpg";